<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div
                                        class="col-md-3"
                                        v-if="valuesIn.name">
                                        <div>
                                            <span>{{ $t('common.name') }}: {{ valuesIn.name }}</span
                                            ><br />
                                        </div>
                                        <div v-if="!valuesIn.parent.value">
                                            <span>{{ $t('group.course') }}: {{ valuesIn.course.text }}</span
                                            ><br />
                                        </div>
                                        <div v-if="!valuesIn.parent.value">
                                            <span>{{ $t('group.school_year') }}: {{ valuesIn.season.text }}</span>
                                        </div>
                                        <div v-if="!valuesIn.parent.value">
                                            <span>Start: {{ valuesIn.start }}</span>
                                        </div>
                                        <div v-if="!valuesIn.parent.value">
                                            <span>{{ $t('group.end') }}: {{ valuesIn.end }}</span>
                                        </div>
                                        <div v-if="!questions.type.live && questions.type.value">
                                            <span>Type: {{ selectedType.text }}</span>
                                        </div>
                                        <div v-if="!questions.editor.live && questions.editor.value">
                                            <span>Type: {{ selectedEditor.text }}</span>
                                        </div>
                                    </div>
                                    <div class="offset-md-3 col-md-5">
                                        <div v-if="questions.type.live">
                                            <label for="group-create-type-select">Type</label>
                                            <b-form-select
                                                id="group-create-type-select"
                                                v-model="questions.type.value"
                                                :options="questions.type.types"
                                                @change="
                                                    portfolioCopyGroupId = null;
                                                    questions.copy.value = null;
                                                    selectedPortfolioSchool = null;
                                                    selectedQuestSchool = null;
                                                "
                                                style="margin-top: 20px"></b-form-select>
                                            <b-form-invalid-feedback :state="valid">
                                                {{ $t('group.choose_type_before_you_go_further') }}
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div v-if="questions.editor.live">
                                            <label for="group-create-editor-select">{{
                                                $t('common.editor_type')
                                            }}</label>
                                            <b-form-select
                                                id="group-create-editor-type-select"
                                                v-model="questions.editor.value"
                                                :options="questions.editor.types"
                                                style="margin-top: 20px"></b-form-select>
                                            <b-form-invalid-feedback :state="valid">
                                                {{ $t('group.choose_editor_before_you_go_further') }}
                                            </b-form-invalid-feedback>
                                        </div>
                                        <div v-if="questions.copy.live && [2, 6].includes(questions.type.value)">
                                            <div>
                                                <label>{{ $t('group.copy_portfolio_from_existing_group') }}</label>
                                                <b-form-checkbox
                                                    v-model="questions.copy.value"
                                                    @change="getSchoolsForPortfolio"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch></b-form-checkbox>
                                            </div>
                                            <div
                                                v-if="questions.copy.value === '1'"
                                                style="margin-top: 30px">
                                                <label>{{ $t('group.choose_school') }}</label>
                                                <b-form-select
                                                    id="group-create-editor-type-select-school"
                                                    v-model="selectedPortfolioSchool"
                                                    :options="portfolioSchools"
                                                    @change="selectedSchoolChangeForPortfolio"></b-form-select>
                                            </div>
                                            <div
                                                v-if="questions.copy.value === '1' && selectedPortfolioSchool"
                                                style="margin-top: 30px">
                                                <label>{{ $t('group.choose_group') }}</label>
                                                <b-form-select
                                                    id="group-create-editor-type-select"
                                                    v-model="portfolioCopyGroupId"
                                                    :options="portfolioGroups"></b-form-select>
                                            </div>
                                        </div>
                                        <div v-if="questions.copy.live && questions.type.value === 3">
                                            <div>
                                                <label>{{ $t('group.copy_quest_from_existing_group') }}</label>
                                                <b-form-checkbox
                                                    v-model="questions.copy.value"
                                                    @change="getSchoolsForQuest"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch>
                                                </b-form-checkbox>
                                            </div>
                                            <div
                                                v-if="questions.copy.value === '1'"
                                                style="margin-top: 30px">
                                                <label>{{ $t('group.choose_group') }}</label>
                                                <b-form-select
                                                    id="group-create-editor-type-select-school"
                                                    v-model="selectedQuestSchool"
                                                    :options="questSchools"
                                                    @change="selectedSchoolChangeForQuest"></b-form-select>
                                            </div>
                                            <div
                                                v-if="questions.copy.value === '1' && selectedQuestSchool"
                                                style="margin-top: 30px">
                                                <label>{{ $t('group.choose_group') }}</label>
                                                <b-form-select
                                                    id="group-create-editor-type-select"
                                                    v-model="questCopyGroupId"
                                                    :options="questGroups"></b-form-select>
                                            </div>
                                        </div>
                                        <div style="margin-top: 20px">
                                            <b-form-invalid-feedback :state="valid">
                                                {{ $t('group.choose_group_before_you_go_further') }}
                                            </b-form-invalid-feedback>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-create-tab-type-component',
    props: ['valuesIn', 'schoolSettingsIn'],
    data() {
        const self = this;
        return {
            valid: true,
            currentQuestion: null,

            portfolioSchools: [],
            portfolioGroups: [],
            selectedPortfolioSchool: null,
            portfolioCopyGroupId: null,

            questSchools: [],
            questGroups: [],
            selectedQuestSchool: null,
            questCopyGroupId: null,

            questions: {
                type: {
                    live: false,
                    passed: false,
                    value: null,
                    types: [
                        { value: null, text: this.$t('group.choose_type') },
                        { value: 1, text: this.$t('group.paper') },
                        { value: 2, text: 'Portfolio' },
                        { value: 3, text: 'Quest' },
                        { value: 4, text: 'Magazine' },
                        { value: 6, text: 'Stage' },
                    ],
                    valid() {
                        return this.value;
                    },
                    activate() {
                        this.live = true;
                    },
                    next() {
                        if (this.value < 4 || this.value === 6) {
                            this.live = false;
                            this.passed = true;
                            if (this.value === 3) {
                                self.$emit('enable-finish');
                            }

                            return 'editor';
                        } else {
                            return false;
                        }
                    },
                    previous() {
                        this.live = true;
                    },
                },
                editor: {
                    live: false,
                    passed: false,
                    value: this.schoolSettingsIn.editor_type,
                    types: [
                        { value: null, text: this.$t('group.choose_editor_type') },
                        { value: 'oo', text: 'Only Office' },
                        { value: 'moo', text: 'Microsoft Office Online' },
                        { value: 'sp', text: 'Office 365' },
                        { value: 'gd', text: 'Google Docs' },
                    ],
                    valid() {
                        return this.value;
                    },
                    activate() {
                        this.live = true;
                    },
                    next() {
                        this.live = false;
                        this.passed = true;
                        if ([2, 3, 6].includes(self.questions.type.value)) {
                            return 'copy';
                        } else {
                            return false;
                        }
                    },
                    previous() {
                        this.live = false;
                        return 'type';
                    },
                },
                copy: {
                    live: false,
                    passed: false,
                    value: null,
                    activate() {
                        this.live = true;
                    },
                    next() {
                        // this.live = false;
                        // this.passed = true;
                    },
                    previous() {
                        this.live = false;
                        return 'editor';
                    },
                    valid() {
                        if (!this.value) {
                            return true;
                        }
                        if ([2, 6].includes(self.questions.type.value) && self.portfolioCopyGroupId) {
                            return true;
                        }
                        if (self.questions.type.value === 3 && self.questCopyGroupId) {
                            return true;
                        }
                        return false;
                    },
                },
            },
        };
    },
    computed: {
        selectedType() {
            for (const type of this.questions.type.types) {
                if (type.value === this.questions.type.value) {
                    return type;
                }
            }
        },
        selectedEditor() {
            for (const type of this.questions.editor.types) {
                if (type.value === this.questions.editor.value) {
                    return type;
                }
            }
        },
    },
    methods: {
        next() {
            if (!this.currentQuestion.valid()) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }

            const nextQuestion = this.currentQuestion.next();
            if (nextQuestion) {
                if (nextQuestion === this.secondQuestion) {
                    this.$emit('enable-prev');
                }
                this.currentQuestion = this.questions[nextQuestion];
                this.currentQuestion.activate();
                return false;
            } else {
                return {
                    type: this.selectedType,
                    editor: this.selectedEditor,
                    portfolio_group_copy: this.portfolioCopyGroupId,
                    quest_group_copy: this.questCopyGroupId,
                };
            }
        },
        previous() {
            this.$emit('disable-finish'); // todo make dynamic when extended
            const previousQuestion = this.currentQuestion.previous();
            if (previousQuestion) {
                this.currentQuestion = this.questions[previousQuestion];
                this.valid = true;
                this.currentQuestion.activate();
                return false;
            }
            return true;
        },
        getSchoolsForPortfolio(value) {
            this.portfolioCopyGroupId = null;
            if (value === '0' || this.portfolioSchools.length) {
                return;
            }

            this.alert.saving(this.$t('group.load_schools'), this.$t('group.one_moment_load_schools'));
            this.axios.get(this.routes.schoolHavePortfolio()).then(
                (response) => {
                    this.portfolioSchools = response.data.map((school) => {
                        return {
                            value: school.id,
                            text: school.name + ' (' + school.id + ')',
                        };
                    });
                    this.alert.close();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        selectedSchoolChangeForPortfolio(value) {
            if (!value) {
                this.selectedPortfolioSchool = null;
                return;
            }
            this.portfolioCopyGroupId = null;

            this.alert.saving(this.$t('group.load_groups'), this.$t('group.one_moment_load_groups'));
            this.axios.get(this.routes.groupHavePortfolio(value)).then(
                (response) => {
                    this.portfolioGroups = response.data.map((group) => {
                        return {
                            value: group.id,
                            text: group.name + ' (' + group.id + ')',
                        };
                    });
                    this.alert.close();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        getSchoolsForQuest(value) {
            this.questCopyGroupId = null;
            if (value === '0' || this.questSchools.length) {
                return;
            }

            this.alert.saving(this.$t('group.load_schools'), this.$t('group.one_moment_load_schools'));
            this.axios.get(this.routes.schoolHaveQuest()).then(
                (response) => {
                    this.questSchools = response.data.map((school) => {
                        return {
                            value: school.id,
                            text: school.name + ' (' + school.id + ')',
                        };
                    });
                    this.alert.close();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        selectedSchoolChangeForQuest(value) {
            if (!value) {
                this.selectedQuestSchool = null;
                return;
            }
            this.questCopyGroupId = null;

            this.alert.saving(this.$t('group.load_groups'), this.$t('group.one_moment_load_groups'));
            this.axios.get(this.routes.groupHaveQuest(value)).then(
                (response) => {
                    this.questGroups = response.data.map((group) => {
                        return {
                            value: group.id,
                            text: group.name + ' (' + group.id + ')',
                        };
                    });
                    this.alert.close();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    mounted() {
        this.questions.type.activate();
        this.currentQuestion = this.questions.type;
    },
};
</script>

<style scoped></style>
